import { z } from "zod/v4";

export const BannerSchema = z.object({
  id: z.uuid(),
  message: z.string(),
  backgroundColor: z.string(),
  textColor: z.string(),
  // These must be nullish
  fontFamily: z.string().default("inherit").optional(),
  redirectUrl: z.string().nullish(),
  isSticky: z.boolean().default(false),
  fontSize: z.string().default("18px").nullish(),
  customCss: z.any(),
  enabled: z.boolean().default(false),

  //  FE ONLY
  isDefault: z.boolean().optional(),
});

export type BannerConfigType = z.infer<typeof BannerSchema>;
